import { createInertiaApp } from '@inertiajs/react'

import { installStorageFallback } from '../lib/safeStorage.js'
import { inertiaAppOptions } from './inertiaAppOptions.js'

// Inertia reads window.sessionStorage for history encryption; blocked storage must not break the page.
installStorageFallback()

createInertiaApp(inertiaAppOptions)
